import { useCallback, useEffect, useState } from "react";
import { getCompaniesList } from "../network";
import { useAuth } from "../../../auth/useAuth";
import { TCompany } from "../models";
import { TPagingResponse } from "../../../models/PagingResponse";

export const useCompaniesList = (
  noRequest?: boolean
): [TPagingResponse<TCompany> | null, boolean, Error | null, () => void] => {
  const { setCompanies } = useAuth();
  const [result, setResult] = useState<TPagingResponse<TCompany> | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await getCompaniesList();
      setResult(response);
      setCompanies(response);
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    } finally {
      setIsLoading(false);
    }
  }, [setCompanies]);

  useEffect(() => {
    if (!noRequest) {
      request();
    }
  }, [request, noRequest]);

  return [result, isLoading, error, request];
};
